import React from 'react';
import UserAvatar from 'treeline-react-core-components/UserAvatar';
import { useUser } from '../../User/containers/UserDataStore';

export default function ProfileEditorUserAvatar() {
	const userDataStore = useUser();
	const { userAvatar } = userDataStore.state;

	return (
		<UserAvatar
			userInitials={userAvatar && userAvatar.initials}
			avatarUri={userAvatar && userAvatar.uri}
			displayName={userAvatar && userAvatar.displayName}
			avatarSizeClass="avatar-large"
		/>
	);
}
